import { KgInsightCohortTable } from '@api/api/kg-insights';
import { Badge } from '@design/components/badge/Badge';
import { useTheme } from '@terminal/react-query-hooks/themes/useThemeOverview';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeHeaderView } from '../../components/theme-header/ThemeHeaderView';
import {
  SENTIMENT_BADGE_COLOR,
  THEME_TAG_KIND_MAP,
} from '../../kg-insight-constants';
import { ReflexivityGraphLayout } from '../../ReflexivityGraphLayout';

export interface ThemeCardProps {
  cohort: KgInsightCohortTable;
  cohortReadTitle: string;
  askAlfredSuggestions: string[];
  children: React.ReactNode;
}

export const ThemeCard = ({
  cohort,
  cohortReadTitle,
  askAlfredSuggestions,
  children,
}: ThemeCardProps) => {
  const { t } = useTranslation(['insights']);
  const { data: themeData } = useTheme({
    themeId: cohort.data.theme_id,
  });

  return (
    <ReflexivityGraphLayout
      color={themeData?.type && THEME_TAG_KIND_MAP[themeData?.type]}
      cohortReadTitle={cohortReadTitle}
      askAlfredSuggestions={askAlfredSuggestions}
      headerNode={
        themeData && (
          <ThemeHeaderView
            themeData={themeData}
            badge={
              <Badge
                color={SENTIMENT_BADGE_COLOR[cohort.data.sentiment]}
                size="xsmall"
                label={t(
                  'insights:catalystGeneration.reflexivityGraph.sentiment',
                  { context: cohort.data.sentiment }
                )}
              />
            }
          />
        )
      }
      description={cohort.data.subtitle}
      cohortRead={cohort.data.read}
    >
      {children}
    </ReflexivityGraphLayout>
  );
};
